import watchFinancialSituation from './financialSituation'

export default watchFinancialSituation
